<p-table [columns]="tableCols" [value]="masterLists" selectionMode="single" [(selection)]="selectedMasterList"
  (onRowSelect)="onRowSelect($event)" [loading]="loading">
  <ng-template pTemplate="caption">
    {{title}}
  </ng-template>

  <ng-template pTemplate="header" let-columns>
    <tr>
      <th id="{{col.field+'Column'}}" *ngFor="let col of columns"
        [ngStyle]="{'width': col.width ,'display': col.display}"
        [pSortableColumn]="col.field=='lab' ? col.sort:col.field">
        {{col.header}}
        <p-sortIcon [field]="col.field=='lab' ? col.sort:col.field"></p-sortIcon>
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-rowData let-columns="columns">
    <tr [pSelectableRow]="rowData">
      <ng-container *ngFor="let col of columns">
        <td class="wrapword" [ngStyle]="{'display': col.display}" *ngIf="col.field != 'active' && col.field != 'lab' && col.field != 'capabilities'">
          {{rowData[col.field]}}
        </td>
        <td *ngIf="col.field == 'active'">
          <p-checkbox id="active" disabled [(ngModel)]="rowData[col.field]" binary="true"></p-checkbox>
        </td>
        <td *ngIf="col.field == 'lab' ">
          {{rowData[col.field]!= null? rowData[col.field].name :''}}
        </td>
      </ng-container>
    </tr>
  </ng-template>
  <ng-template pTemplate="summary" let-rowData>
    <div class="textAlignment">
      <button type="button" pButton class="h-2rem" icon="pi pi-plus" (click)="showDialogToAddMasterList()" label="Add"></button>
    </div>
  </ng-template>
</p-table>

<p-dialog header="{{title}} Details" position="top" [(visible)]="displayMasterListDialog" [focusOnShow]="false" showEffect="fade" [modal]="true" [style]="{'width':'600px'}"
 [contentStyle]="{'overflow':'auto'}" [baseZIndex]="1000">
  <div *ngIf="masterList">
    <div *ngFor="let col of tableCols">
      <div class="form-group m-2">
        <div  *ngIf="col.field != 'capabilities'">
          <label>{{col.header}}</label>
       </div>
        <div *ngIf="col.field == 'flowCellName'">
          <input pInputText class="form-control" [(ngModel)]="masterList[col.field]" [ngClass]=" { 'disableTextBox' : isFlowcellName(col.field) }"
            (change)="masterList[col.field]=masterList[col.field].trim()">
        </div>

        <div *ngIf="col.field == 'lab'">
          <p-dropdown [options]="labOptions" [(ngModel)]="selectedLab" filter="true" filterBy="label" placeholder="Select a Lab"
            optionLabel="name" [showClear]="true"></p-dropdown>
        </div>

        <div *ngIf="col.field == 'sequencer'">
          <p-dropdown [options]="sequencerOptions" filter="true"  filterBy="label" placeholder="Select a Sequencer"
            optionLabel="name" [showClear]="true" [(ngModel)]="selectedSequencer" ></p-dropdown>
        </div>

        <div *ngIf="col.field == 'flowCellType'">
          <p-dropdown [options]="flowCellTypeOptions" filter="true"  filterBy="label" placeholder="Select a Type"
             [showClear]="true" [(ngModel)]="selectedFlowCellType" ></p-dropdown>
        </div>

        <div *ngIf="col.field == 'flowCellMode'">
          <p-dropdown [options]="flowCellModeOptions" filter="true"  filterBy="label" placeholder="Select a Mode"
             [showClear]="true" [(ngModel)]="selectedFlowCellMode" ></p-dropdown>
        </div>

        <div *ngIf="col.field == 'physicalLanes'">
          <input pInputText type="number" step="1" min="1" max="8" style="width: 5rem; height: 2.5rem;" [(ngModel)]="masterList.physicalLanes">
          <span *ngIf="physicalLanesCheck()" class="warningMsg"><small class="p-invalid">Range 1-8 </small></span>
        </div>

        <div *ngIf="col.field == 'logicalLanes'">
          <input pInputText type="number" step="1" min="1" max="{{masterList.physicalLanes}}" style="width: 5rem; height: 2.5rem;"
            [(ngModel)]="masterList.logicalLanes" (change)="onValueChange()">
          <label> (independent lanes for planning) </label>
          <span *ngIf="logicalLanesCheck()" class="warningMsg"><small class="p-invalid">Range 1- {{masterList.physicalLanes}} </small></span>
        </div>

        <div *ngIf="col.field == 'totalCapacity'">
          <input pInputText type="number" step="1" min="1" max="99999" style="width: 5rem; height: 2.5rem;" [(ngModel)]="masterList.totalCapacity"
            (change)="onValueChange()">
          <label> Million Reads </label>
          <span *ngIf="totalCapacityCheck()" class="warningMsg"><small class="p-invalid">Range 1-99999 </small></span>
        </div>

        <div *ngIf="col.field == 'laneCapacity'">
          <input pInputText type="number" step="1" style="width: 5rem; height: 2.5rem;" [(ngModel)]="masterList.laneCapacity" [disabled] = "true">
          <label> Million Reads </label>
        </div>

        <div *ngIf="col.field == 'capabilities'">
          <p-fieldset legend="Read modes">
            <div class="col">
              <div class="col-12 col-nopad">
                <div class="col-12 flex">
                  <button pButton class="theme-button noHover" style="height:2.5rem;" type="button" label="Mode"></button>
                  <p-dropdown [options]="capabilityModeOptions" filter="true" filterBy="label" placeholder="Select"
                    [showClear]="true" [(ngModel)]="selectedCapabilityMode"></p-dropdown>
                </div>
                <div class="col-12 flex">
                  <button pButton class="theme-button noHover" style="height:2.5rem;" type="button" label="Length"></button>
                  <input pInputText type="number" step="1" min="1" style="width: 5rem;height: 2.5rem;" [(ngModel)]="capabilityLength">
                  <label class="p-2"> bases </label>
                </div>
                <div class="col-12 flex">
                  <button pButton class="theme-button noHover" style="height:2.5rem;" type="button" label="Duration"></button>
                  <input pInputText type="number" step="1" min="1" style="width: 5rem;height: 2.5rem;" [(ngModel)]="capabilityDuration">
                  <label class="p-2"> hours </label>
                </div>
              </div>
              <div class="col-6">
                <p-listbox [options]="capabilityListMode" [(ngModel)]="selectedCapability"
                  optionLabel="label"></p-listbox>
              </div>
            </div>
            <div class="col flex">
              <div class="col-6">
                <button type="button" pButton icon="pi pi-plus-circle" label="Add" class="h-2rem"
                  [disabled]="isAddDisabled()" (click)="addFlowCellCapability()"></button>
              </div>
              <div class="col-6">
                <button type="button" pButton icon="pi pi-times-circle" label="Delete" class="h-2rem"
                  (click)="removeFlowCellCapability(selectedCapability)"></button>
              </div>
            </div>
          </p-fieldset>
        </div>
        <div *ngIf="col.field == 'active'">
          <p-checkbox [(ngModel)]="masterList[col.field]" binary="true"></p-checkbox>
        </div>
      </div>
    </div>
  </div>
  <div class="ui-dialog-buttonpane ui-helper-clearfix flex justify-content-end">
    <button type="button" pButton icon="pi pi-check" [disabled]="isSaveDisabled()" (click)="saveMasterListData()"
      label="Save" class="h-2rem"></button>
  </div>
</p-dialog>

<p-dialog header="Confirm on flowcell Read Modes" [(visible)]="dialogBoxCell"[focusOnShow]="false" showEffect="fade" [modal]="true" [style]="{'width':'600px'}"
 [contentStyle]="{'overflow':'auto'}" [baseZIndex]="1000">
  <div>
    <span>Do you want to change existing Read mode "{{oldCellMode}}" to "{{newCellMode}}" ?</span>
  </div>
  <div style="margin-top: 4%;margin-left: 22%;">
    <button type="button" pButton (click)="updateReadMode()" label="Yes" class="float-left"></button>
  </div>
  <div style="margin-right: 36%;margin-top: 4%;">
    <button type="button" pButton (click)="disableDialog()" label="No" class="float-right"></button>
  </div>
</p-dialog>
